import React from 'react'
import {Header} from './components/header'
import {Sidebar} from './components/sidebar'
import Scrollbars from 'react-custom-scrollbars-2'
import {building} from '../imagepath'
const Layout = ({children}) => (
  <>
    <Header />
    <Sidebar />
    {children}
  </>
)

export default Layout
